<template>
    <div class="input-cont">
        <div class="input-container" v-for="(input, key) in registerFields.addressData" :key="key" :class="{ half: input.half }">
            <label v-if="input.type != 'select'" autocomplete="off" :for="getId(input.display)" v-text="input.display" :class="{ required: input.required }"></label>
            <span v-else :for="getId(input.display)" v-text="input.display" :class="{ required: input.required }"></span>
            <input v-if="input.type != 'select'" :maxlength="input.maxlength ? input.maxlength : ''" :id="getId(input.display)" :placeholder="input.placeHolder" :type="input.type" v-model="formattedValue[getId(input.display)]" ref="input" @input="changeValue(getId(input.display), input.format)" @blur="onBlurAction(input)"/>
            <div v-else class="select" autocomplete="off" :class="{'disabled' : isDisabled(getId(input.display))}" :type="input.type" @click="selectList(getId(input.display))" ref="input" v-text="(getAddressData[getId(input.display)][input.optionDisplay]) || input.placeHolder"></div>
        </div>
        <SelectList></SelectList>
        <ScreenLoader :isLoading="wait"></ScreenLoader>
    </div>
</template>

<script>
import SelectList from '../bottom-popups/SelectList.vue'
import { mapGetters, mapActions } from 'vuex'
import { getStates, getCities } from '@/components/controllers/RegisterController'
import ScreenLoader from '@/components/loader/ScreenLoader.vue'
import { findCep } from '@/libs/Util.js'
import { log } from '@/libs/Logger'

export default {
    name: 'InputsAddress',
    components: {
        SelectList,
        ScreenLoader
    },
    props: ['inputs'],
    data () {
        return {
            states: [],
            cities: [],
            formattedValue: {},
            wait: false
        }
    },
    computed: {
        ...mapGetters(['registerFields', 'getAddressData'])
    },
    methods: {
        ...mapActions(['showSelectList', 'closeSelectList', 'setAddressCitieData', 'setAddressData']),
        getId: function (display) {
            return display.replaceAll(' ', '').toLowerCase().normalize('NFD').replace(/[^a-zA-Z\s]/g, '')
        },
        selectList: async function (id) {
            let data = {}
            this.wait = true
            if (id === 'uf') {
                this.states = await getStates()
                this.setAddressCitieData({})
                this.showSelectList({ title: 'UF', options: this.states, optionDisplay: 'NMESTADO', event: 'setAddressUfData' })
            }
            if (id === 'municipio') {
                data = {
                    SGESTADO: this.getAddressData.uf.SGESTADO
                }
                this.cities = await getCities(data)
                this.showSelectList({ title: 'Município', options: this.cities, optionDisplay: 'NMMUNICIPIO', event: 'setAddressCitieData' })
            }
            this.wait = false
        },
        isDisabled: function (id) {
            if (id === 'municipio') {
                return !this.getAddressData.uf.SGESTADO || (this.getAddressData.uf.SGESTADO.length === 0)
            }
            if (id === 'bairro') {
                return !this.getAddressData.uf.SGESTADO || (this.getAddressData.uf.SGESTADO.length === 0) ||
                (!this.getAddressData.municipio.CDMUNICIPIO || (this.getAddressData.municipio.CDMUNICIPIO.length === 0))
            }
            return false
        },
        changeValue: function (id, format) {
            if (format === 'cep') {
                this.formattedValue[id] = this.formattedValue[id].replace(/\D/g, '')
                this.formattedValue[id] = this.formattedValue[id].replace(/(\d{5})(\d)/, '$1-$2')
                this.formattedValue[id] = this.fixInputLength(this.formattedValue[id], 9)
            }
            if (format === 'number') {
                this.formattedValue[id] = this.formattedValue[id].replace(/[^0-9]/g, '')
            }
            this.setAddressData({ id: id, value: this.formattedValue[id] })
        },
        fixInputLength (inputValue, length) {
            if (inputValue.length > length) {
                inputValue = inputValue.slice(0, length)
            }
            return inputValue
        },
        onBlurAction (input) {
            if (input.onBlurAction) {
                try {
                    this[input.onBlurAction](input)
                } catch (error) {
                    log({ type: 'error', message: error?.message })
                }
            }
        },
        fillAdressByCEP: function (input) {
            findCep(this.getAddressData.cep).then(result => {
                if (result?.logradouro) {
                    const addressId = this.getId('Endereço')
                    this.formattedValue[addressId] = result.logradouro
                    this.changeValue(addressId, null)
                }
            })
        }
    }
}
</script>

<style lang="less" scoped>
.input-cont {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
}

.input-container {
  margin-bottom: 15px;
  font-size: 16px;

    &.half {
        width: calc(50% - 10px);
    }

    // no half
    &:not(.half) {
        display: block;
        width: calc(100%);
    }

    label {
        display: block;
        margin-bottom: 5px;

        &.required:after {
        content: '*';
        color: red;
        margin-left: 5px;
        }
    }
    span {
        display: block;
        margin-bottom: 5px;

        &.required:after {
        content: '*';
        color: red;
        margin-left: 5px;
        }
    }
    input {
        width: calc(100% - 30px);
        padding: 15px;
        font-size: 16px;
        border: 1px solid rgba(0, 0, 0, 0.2);
        border-radius: 7px;
        margin-top: 10px;
    }
    .select {
        width: calc(100% - 30px);
        padding: 15px;
        font-size: 16px;
        border: 1px solid rgba(0, 0, 0, 0.2);
        border-radius: 7px;
        margin-top: 10px;
    }
    .select.disabled {
            background-color:whitesmoke;
            pointer-events: none;
    }
}
.overlay {
    position: fixed;
    top: 0; left: 0;
    height: 100vh;
    width: 100vw;
    overflow: hidden;
    background: rgba(0, 0, 0, 0.21);
    z-index: 2;
}
</style>
